import { useEffect, useState } from 'react';
import { Visibility } from './Visibility';
import type { VisibilityState, Breakpoint } from '@builder4/shared/types/layout';
import { useInspectorNode } from '@/hooks/useInspectorNode';

interface VisibilityProps {
  visibility: VisibilityState | undefined;
}

const NodeVisibilitySettings = () => {
  const { id, props, actions } = useInspectorNode<VisibilityProps>((p) => ({
    visibility: p.visibility as VisibilityState | undefined,
  }));

  const [visibilityState, setVisibilityState] = useState<Breakpoint[]>([]);

  const handleOnChange = (devices: Breakpoint[]) => {
    const newState: VisibilityState = {
      desktop: devices.includes('desktop'),
      tablet: devices.includes('tablet'),
      mobile: devices.includes('mobile'),
    };
    actions.setProp(id, (p: { visibility?: VisibilityState }) => {
      p.visibility = newState;
    });
  };

  useEffect(() => {
    if (props.visibility) {
      const activeDevices = Object.entries(props.visibility)
        .filter(([, value]) => value)
        .map(([key]) => key as Breakpoint);
      setVisibilityState(activeDevices);
    }
  }, [props.visibility]);

  return (
    <Visibility
      selected={visibilityState}
      onChange={handleOnChange}
      text="Visibility"
      className=""
    />
  );
};

export default NodeVisibilitySettings;
